import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Layers, FileText, ArrowRight, Settings, Info } from "lucide-react";

const DIRECTORY_ITEMS = [
  {
    icon: Layers,
    title: "To Stage / Setup Gate",
    desc: "Destination workflow stage (Access key to activate entries)."
  },
  {
    icon: FileText,
    title: "Voucher Serial No",
    desc: "Unique alphanumeric identifier. Mandatory for save validation."
  },
  {
    icon: ArrowRight,
    title: "From Stage",
    desc: "Select origin process point. Auto-synchronised from Setup gate selection."
  },
  {
    icon: Settings,
    title: "Process Parameters",
    desc: "Shift (Duty hours track), In-Time / Out-Time (Cycle duration), Weight in kg (Chemical loading metrics)."
  },
  {
    icon: Info,
    title: "Dual Workspace Allocation",
    desc: "Available rolls represent grey cloth inventory pool. Allocated rolls represent actively linked lot cards for this process. Issues cannot exceed origin capacity."
  }
];

const HelpModal = ({
  show,
  onHide,
  themeColors
}) => {
  const {
    bgCard,
    textTheme,
    borderTheme,
    btnBg,
    isdark,
    iscolour
  } = themeColors;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
    >
      <Modal.Header
        closeButton
        style={{
          background: bgCard,
          color: textTheme,
          borderBottom: `1px solid ${borderTheme}`
        }}
      >
        <Modal.Title style={{ fontSize: "18px", fontWeight: "700" }}>
          Lot Allocation Fields Directory
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          background: bgCard,
          color: textTheme
        }}
      >
        <div className="d-flex flex-column gap-3">
          {DIRECTORY_ITEMS.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div
                key={index}
                style={{
                  background: isdark === "light" ? "#fbfbfa" : "rgba(255, 255, 255, 0.02)",
                  border: `1px solid ${borderTheme}`,
                  borderRadius: "12px",
                  padding: "16px 20px",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                  transition: "all 0.3s ease"
                }}
                className="hover-card-glowing"
              >
                <div
                  style={{
                    background: isdark === "light" ? `${btnBg}10` : "rgba(255, 255, 255, 0.05)",
                    color: btnBg,
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <IconComponent size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <h6 
                    style={{ 
                      margin: "0 0 6px 0", 
                      fontWeight: "700", 
                      color: isdark === "light" ? iscolour?.Colour9 || "#334155" : "#fff",
                      fontSize: "14px"
                    }}
                  >
                    {item.title}
                  </h6>
                  <p 
                    style={{ 
                      margin: 0, 
                      fontSize: "13px", 
                      color: isdark === "light" ? "#64748b" : "#94a3b8",
                      lineHeight: "1.5"
                    }}
                  >
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          background: bgCard,
          borderTop: `1px solid ${borderTheme}`
        }}
      >
        <Button variant="secondary" onClick={onHide}>
          Close Guide
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HelpModal;
